// src/components/Countdown.js
import React, { useState, useEffect } from "react";
import "../styles/Countdown.css";

const Countdown = () => {
  // Fecha límite para registrar casas
  const registrationDeadline = new Date("2025-12-19T23:59:59");

  const calculateTimeLeft = () => {
    const now = new Date();
    const difference = registrationDeadline - now;
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft = null; // Registro cerrado
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  if (!timeLeft) {
    return <p className="countdown-message">Registration is now closed!</p>;
  }

  return (
    <div className="countdown">
      <h2>✨ Register Your Home Before Time Runs Out! ✨</h2>
     
      <div className="countdown-timer">
        <div className="time-box">
          <span>{timeLeft.days}</span>
          <small>Days</small>
        </div>
        <div className="time-box">
          <span>{timeLeft.hours}</span>
          <small>Hours</small>
        </div>
        <div className="time-box">
          <span>{timeLeft.minutes}</span>
          <small>Minutes</small>
        </div>
        <div className="time-box">
          <span>{timeLeft.seconds}</span>
          <small>Seconds</small>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
